import React from 'react';
import { useQuery } from '../../hooks/use-query';
import ApiTokenCreateApp from './create-app';
import ApiTokenCreateCustom from './create-custom';

export default function ApiTokenCreate() {
  const [params] = useQuery();

  if (params['return-url'] && params.name) {
    return (
      <ApiTokenCreateApp
        name={params.name}
        returnUrl={params['return-url']}
        method={params.method}
      />
    );
  } else {
    return <ApiTokenCreateCustom name={params.name} />;
  }
}
